export const CUSTOMER_STATUS_CHANGE = "CUSTOMER_STATUS_CHANGE";
export const CUSTOMER_STATUS_CHANGE_SUCCESS = "CUSTOMER_STATUS_CHANGE_SUCCESS";
export const CUSTOMER_STATUS_CHANGE_FAIL = "CUSTOMER_STATUS_CHANGE_FAIL";

export const CUSTOMER_LIST = "CUSTOMER_LIST";
export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_LIST_FAIL = "CUSTOMER_LIST_FAIL";

export const CUSTOMER_DETAIL = "CUSTOMER_DETAIL";
export const CUSTOMER_DETAIL_SUCCESS = "CUSTOMER_DETAIL_SUCCESS";
export const CUSTOMER_DETAIL_FAIL = "CUSTOMER_DETAIL_FAIL";

export const SHOPPER_STATUS_CHANGE = "SHOPPER_STATUS_CHANGE";
export const SHOPPER_STATUS_CHANGE_SUCCESS = "SHOPPER_STATUS_CHANGE_SUCCESS";
export const SHOPPER_STATUS_CHANGE_FAIL = "SHOPPER_STATUS_CHANGE_FAIL";

export const SHOPPER_LIST = "SHOPPER_LIST";
export const SHOPPER_LIST_SUCCESS = "SHOPPER_LIST_SUCCESS";
export const SHOPPER_LIST_FAIL = "SHOPPER_LIST_FAIL";

export const PERSONAL_SHOPPER_LIST = "PERSONAL_SHOPPER_LIST";
export const PERSONAL_SHOPPER_LIST_SUCCESS = "PERSONAL_SHOPPER_LIST_SUCCESS";
export const PERSONAL_SHOPPER_LIST_FAIL = "PERSONAL_SHOPPER_LIST_FAIL";

export const SHOPPER_DETAIL = "SHOPPER_DETAIL";
export const SHOPPER_DETAIL_SUCCESS = "SHOPPER_DETAIL_SUCCESS";
export const SHOPPER_DETAIL_FAIL = "SHOPPER_DETAIL_FAIL";

export const SHOPPER_ADD = "SHOPPER_ADD";
export const SHOPPER_ADD_SUCCESS = "SHOPPER_ADD_SUCCESS";
export const SHOPPER_ADD_FAIL = "SHOPPER_ADD_FAIL";

export const SHOPPER_ROLE_LIST = "SHOPPER_ROLE_LIST";
export const SHOPPER_ROLE_LIST_SUCCESS = "SHOPPER_ROLE_LIST_SUCCESS";
export const SHOPPER_ROLE_LIST_FAIL = "SHOPPER_ROLE_LIST_FAIL";

export const PRODUCT_STATUS_CHANGE = "PRODUCT_STATUS_CHANGE";
export const PRODUCT_STATUS_CHANGE_SUCCESS = "PRODUCT_STATUS_CHANGE_SUCCESS";
export const PRODUCT_STATUS_CHANGE_FAIL = "PRODUCT_STATUS_CHANGE_FAIL";

export const PRODUCT_LIST = "PRODUCT_LIST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";

export const VIRTUAL_LOCKER_LIST = "VIRTUAL_LOCKER_LIST";
export const VIRTUAL_LOCKER_LIST_SUCCESS = "VIRTUAL_LOCKER_LIST_SUCCESS";
export const VIRTUAL_LOCKER_LIST_FAIL = "VIRTUAL_LOCKER_LIST_FAIL";

export const VIRTUAL_LOCKER_STATUS_CHANGE = "VIRTUAL_LOCKER_STATUS_CHANGE";
export const VIRTUAL_LOCKER_STATUS_CHANGE_SUCCESS = "VIRTUAL_LOCKER_STATUS_CHANGE_SUCCESS";
export const VIRTUAL_LOCKER_STATUS_CHANGE_FAIL = "VIRTUAL_LOCKER_STATUS_CHANGE_FAIL";

export const ORDER_STATUS_CHANGE = "ORDER_STATUS_CHANGE";
export const ORDER_STATUS_CHANGE_SUCCESS = "ORDER_STATUS_CHANGE_SUCCESS";
export const ORDER_STATUS_CHANGE_FAIL = "ORDER_STATUS_CHANGE_FAIL";

export const ORDER_LIST = "ORDER_LIST";
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
export const ORDER_LIST_FAIL = "ORDER_LIST_FAIL";

export const ADMIN_ORDER_DETAIL = "ADMIN_ORDER_DETAIL";
export const ADMIN_ORDER_DETAIL_SUCCESS = "ADMIN_ORDER_DETAIL_SUCCESS";
export const ADMIN_ORDER_DETAIL_FAIL = "ADMIN_ORDER_DETAIL_FAIL";

export const ADMIN_ORDER_CHARGES_UPDATE = "ADMIN_ORDER_CHARGES_UPDATE";
export const ADMIN_ORDER_CHARGES_UPDATE_SUCCESS = "ADMIN_ORDER_CHARGES_UPDATE_SUCCESS";
export const ADMIN_ORDER_CHARGES_UPDATE_FAIL = "ADMIN_ORDER_CHARGES_UPDATE_FAIL";

export const ADMIN_ORDER_FINAL_UPDATE = "ADMIN_ORDER_FINAL_UPDATE";
export const ADMIN_ORDER_FINAL_UPDATE_SUCCESS = "ADMIN_ORDER_FINAL_UPDATE_SUCCESS";
export const ADMIN_ORDER_FINAL_UPDATE_FAIL = "ADMIN_ORDER_FINAL_UPDATE_FAIL";

export const ADMIN_ORDER_PACKAGE_NOTES_UPDATE = "ADMIN_ORDER_PACKAGE_NOTES_UPDATE";
export const ADMIN_ORDER_PACKAGE_NOTES_UPDATE_SUCCESS = "ADMIN_ORDER_PACKAGE_NOTES_UPDATE_SUCCESS";
export const ADMIN_ORDER_PACKAGE_NOTES_UPDATE_FAIL = "ADMIN_ORDER_PACKAGE_NOTES_UPDATE_FAIL";

export const SHIPPING_PARTNER_ADD = "SHIPPING_PARTNER_ADD";
export const SHIPPING_PARTNER_ADD_SUCCESS = "SHIPPING_PARTNER_ADD_SUCCESS";
export const SHIPPING_PARTNER_ADD_FAIL = "SHIPPING_PARTNER_ADD_FAIL";

export const SHIPPING_PARTNER_EDIT = "SHIPPING_PARTNER_EDIT";
export const SHIPPING_PARTNER_EDIT_SUCCESS = "SHIPPING_PARTNER_EDIT_SUCCESS";
export const SHIPPING_PARTNER_EDIT_FAIL = "SHIPPING_PARTNER_EDIT_FAIL";

export const SHIPPING_PARTNER_LIST = "SHIPPING_PARTNER_LIST";
export const SHIPPING_PARTNER_LIST_SUCCESS = "SHIPPING_PARTNER_LIST_SUCCESS";
export const SHIPPING_PARTNER_LIST_FAIL = "SHIPPING_PARTNER_LIST_FAIL";

export const SHIPPING_PARTNER_DELETE = "SHIPPING_PARTNER_DELETE";
export const SHIPPING_PARTNER_DELETE_SUCCESS = "SHIPPING_PARTNER_DELETE_SUCCESS";
export const SHIPPING_PARTNER_DELETE_FAIL = "SHIPPING_PARTNER_DELETE_FAIL";

export const SETTING_COUPON_ADD = "SETTING_COUPON_ADD";
export const SETTING_COUPON_ADD_SUCCESS = "SETTING_COUPON_ADD_SUCCESS";
export const SETTING_COUPON_ADD_FAIL = "SETTING_COUPON_ADD_FAIL";

export const SETTING_COUPON_EDIT = "SETTING_COUPON_EDIT";
export const SETTING_COUPON_EDIT_SUCCESS = "SETTING_COUPON_EDIT_SUCCESS";
export const SETTING_COUPON_EDIT_FAIL = "SETTING_COUPON_EDIT_FAIL";

export const SETTING_COUPON_LIST = "SETTING_COUPON_LIST";
export const SETTING_COUPON_LIST_SUCCESS = "SETTING_COUPON_LIST_SUCCESS";
export const SETTING_COUPON_LIST_FAIL = "SETTING_COUPON_LIST_FAIL";

export const SETTING_COUPON_DELETE = "SETTING_COUPON_DELETE";
export const SETTING_COUPON_DELETE_SUCCESS = "SETTING_COUPON_DELETE_SUCCESS";
export const SETTING_COUPON_DELETE_FAIL = "SETTING_COUPON_DELETE_FAIL";

export const SETTING_DECLARATIONS_ADD = "SETTING_DECLARATIONS_ADD";
export const SETTING_DECLARATIONS_ADD_SUCCESS = "SETTING_DECLARATIONS_ADD_SUCCESS";
export const SETTING_DECLARATIONS_ADD_FAIL = "SETTING_DECLARATIONS_ADD_FAIL";

export const SETTING_DECLARATIONS_EDIT = "SETTING_DECLARATIONS_EDIT";
export const SETTING_DECLARATIONS_EDIT_SUCCESS = "SETTING_DECLARATIONS_EDIT_SUCCESS";
export const SETTING_DECLARATIONS_EDIT_FAIL = "SETTING_DECLARATIONS_EDIT_FAIL";

export const SETTING_DECLARATIONS_LIST = "SETTING_DECLARATIONS_LIST";
export const SETTING_DECLARATIONS_LIST_SUCCESS = "SETTING_DECLARATIONS_LIST_SUCCESS";
export const SETTING_DECLARATIONS_LIST_FAIL = "SETTING_DECLARATIONS_LIST_FAIL";

export const SETTING_DECLARATIONS_DELETE = "SETTING_DECLARATIONS_DELETE";
export const SETTING_DECLARATIONS_DELETE_SUCCESS = "SETTING_DECLARATIONS_DELETE_SUCCESS";
export const SETTING_DECLARATIONS_DELETE_FAIL = "SETTING_DECLARATIONS_DELETE_FAIL";



export const SETTING_NOTIFICATION_ADD = "SETTING_NOTIFICATION_ADD";
export const SETTING_NOTIFICATION_ADD_SUCCESS = "SETTING_NOTIFICATION_ADD_SUCCESS";
export const SETTING_NOTIFICATION_ADD_FAIL = "SETTING_NOTIFICATION_ADD_FAIL";

export const SETTING_NOTIFICATION_EDIT = "SETTING_NOTIFICATION_EDIT";
export const SETTING_NOTIFICATION_EDIT_SUCCESS = "SETTING_NOTIFICATION_EDIT_SUCCESS";
export const SETTING_NOTIFICATION_EDIT_FAIL = "SETTING_NOTIFICATION_EDIT_FAIL";

export const SETTING_NOTIFICATION_LIST = "SETTING_NOTIFICATION_LIST";
export const SETTING_NOTIFICATION_LIST_SUCCESS = "SETTING_NOTIFICATION_LIST_SUCCESS";
export const SETTING_NOTIFICATION_LIST_FAIL = "SETTING_NOTIFICATION_LIST_FAIL";

export const SETTING_NOTIFICATION_DELETE = "SETTING_NOTIFICATION_DELETE";
export const SETTING_NOTIFICATION_DELETE_SUCCESS = "SETTING_NOTIFICATION_DELETE_SUCCESS";
export const SETTING_NOTIFICATION_DELETE_FAIL = "SETTING_NOTIFICATION_DELETE_FAIL";

export const SETTING_LOCKER_ADD = "SETTING_LOCKER_ADD";
export const SETTING_LOCKER_ADD_SUCCESS = "SETTING_LOCKER_ADD_SUCCESS";
export const SETTING_LOCKER_ADD_FAIL = "SETTING_LOCKER_ADD_FAIL";

export const SETTING_LOCKER_EDIT = "SETTING_LOCKER_EDIT";
export const SETTING_LOCKER_EDIT_SUCCESS = "SETTING_LOCKER_EDIT_SUCCESS";
export const SETTING_LOCKER_EDIT_FAIL = "SETTING_LOCKER_EDIT_FAIL";

export const SETTING_LOCKER_LIST = "SETTING_LOCKER_LIST";
export const SETTING_LOCKER_LIST_SUCCESS = "SETTING_LOCKER_LIST_SUCCESS";
export const SETTING_LOCKER_LIST_FAIL = "SETTING_LOCKER_LIST_FAIL";

export const SETTING_LOCKER_DELETE = "SETTING_LOCKER_DELETE";
export const SETTING_LOCKER_DELETE_SUCCESS = "SETTING_LOCKER_DELETE_SUCCESS";
export const SETTING_LOCKER_DELETE_FAIL = "SETTING_LOCKER_DELETE_FAIL";

export const SINGEL_SETTING_LOCKER_LIST = "SINGEL_SETTING_LOCKER_LIST";
export const SINGEL_SETTING_LOCKER_LIST_SUCCESS = "SINGEL_SETTING_LOCKER_LIST_SUCCESS";
export const SINGEL_SETTING_LOCKER_LIST_FAIL = "SINGEL_SETTING_LOCKER_LIST_FAIL";

export const SHOPPER_PRICE_ADD = "SHOPPER_PRICE_ADD";
export const SHOPPER_PRICE_ADD_SUCCESS = "SHOPPER_PRICE_ADD_SUCCESS";
export const SHOPPER_PRICE_ADD_FAIL = "SHOPPER_PRICE_FAIL";

export const SHOPPER_PRICE_EDIT = "SHOPPER_PRICE_EDIT";
export const SHOPPER_PRICE_EDIT_SUCCESS = "SHOPPER_PRICE_EDIT_SUCCESS";
export const SHOPPER_PRICE_EDIT_FAIL = "SHOPPER_PRICE_EDIT_FAIL";

export const SHOPPER_PRICE_LIST = "SHOPPER_PRICE_LIST";
export const SHOPPER_PRICE_LIST_SUCCESS = "SHOPPER_PRICE_LIST_SUCCESS";
export const SHOPPER_PRICE_LIST_FAIL = "SHOPPER_PRICE_LIST_FAIL";

export const SHOPPER_PRICE_DELETE = "SHOPPER_PRICE_DELETE";
export const SHOPPER_PRICE_DELETE_SUCCESS = "SHOPPER_PRICE_DELETE_SUCCESS";
export const SHOPPER_PRICE_DELETE_FAIL = "SHOPPER_PRICE_DELETE_FAIL";

export const SINGLE_SHOPPER_PRICE_LIST = "SINGLE_SHOPPER_PRICE_LIST";
export const SINGLE_SHOPPER_PRICE_LIST_SUCCESS = "SINGLE_SHOPPER_PRICE_LIST_SUCCESS";
export const SINGLE_SHOPPER_PRICE_LIST_FAIL = "SINGLE_SHOPPER_PRICE_LIST_FAIL";

export const GROUP_CART_MONITORING_LIST = "GROUP_CART_MONITORING_LIST";
export const GROUP_CART_MONITORING_LIST_SUCCESS = "GROUP_CART_MONITORING_LIST_SUCCESS";
export const GROUP_CART_MONITORING_LIST_FAIL = "GROUP_CART_MONITORING_LIST_FAIL";
